export enum UrlParamsKeys {
  JoinCartId = 'join_cart_id',
  ShareCode = 'share_code',
}
